import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

export const useCollections = ({ paginated = false } = {}) => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'collections',
    gqlEntityKey: 'collections',
    queryName: 'GET_COLLECTIONS_QUERY',
    updateMutation: 'UPDATE_COLLECTION_MUTATION',
    serverPagination: paginated,
    aggregateKey: paginated ? 'collections_aggregate' : null,
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
    transformData: (c) => ({
      id: c.id,
      luca_code: c.luca_code,
      tl_bor: c.tl_bor,
      tl_alacak: c.tl_alacak,
      tl_bakiye: c.tl_bakiye,
      import_date: c.import_date,
      firm_name: c.firm?.firm_name || '—',
      firm_short_name: c.firm?.firm_short_name || '',
      firm_city: c.firm?.firm_city || '',
      firm_id: c.firm?.id,
      reminders: c.reminders || [],
      payment_promises: c.payment_promises || [],
    }),
  });

  return {
    ...dynamicHook,
    collections: dynamicHook.collections,
  };
};

export { useCollectionByFirm } from './useCollectionByFirm';
